<template>
	<div class="index" :style="pageBoxStyle">
		<div class="sixshell">
			<div :class="{ 'flipped': item.isFlipped }" @click="flipCard(item)" v-for="(item,index) in sixbox " style="position: relative;">
				<div class="six front" :style="item.showFlag">
					<img src="/images/meeting/front.jpg" style="width: 100%; height: 100%;position: absolute;z-index: 999;" />
					<div class="headimg" style="border: #000000 1px solid black;">
						<img :src="item.img" />
					</div>
					<!-- <div class="name">{{item.name}}</div> -->
				</div>
				<div class="back six" :style="item.Flag">
					<img src="/images/meeting/back.jpg">
				</div>
			</div>

		</div>
		<div class="boxshell" :style="boxflag">
			<div class="box" :style="box[index]" v-for="(item,index) in 70" @click="licensing(index)">
				<img src="/images/meeting/back.jpg" />
			</div>
		</div>
		<div class="bottom">
			<div class="Lucky" @click="newgame()" style="background: url(/images/meeting/new.png) no-repeat;background-size:100% auto;"></div>
			<div class="Lucky" @click="again()" style="background: url(/images/meeting/wash.png) no-repeat; background-size:100% auto; "></div>
		</div>

	</div>
</template>

<script>
	import request from '../../common/request.js'
	import axios from 'axios'
	export default {
		name: 'HelloWorld',
		props: {
			msg: String
		},
		data() {
			return {
				boxflag: '',
				box: [],
				openflag: false,
				flag: false,
				fanzhuan: '',
				name: '小机灵鬼儿',
				headimg: '../../public/head.jpg',
				count: 1,
				windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
				windowHeight: document.documentElement.clientHeight, //实时屏幕高度
				sixbox: [],

			}
		},
		computed: {
			//页面大小限制样式
			pageBoxStyle() {
				let that = this
				let style = {};
				style.width = that.windowWidth + 'px';
				style.height = that.windowHeight + 'px';
				style.overflow = 'hidden';
				return style;
			},
		},

		created() {
			let that = this
			that.inteStyle()
			that.getWin()



		},
		mounted() {

		},
		methods: {

			//翻牌
			flipCard(card) {
				card.isFlipped = false;

			},
			//初始化牌
			inteStyle() {
				let style = ''
				let that = this
				that.box = []
				that.boxflag = 'box-shadow:  0px 0px 30px #d77813;'
				for (let i = 0; i < 70; i++) {
					style = 'left:' + parseFloat(0 + 10.5 * i) + 'px;' + 'top:' + 0 + 'px;' + 'z-index:' +
						i
					that.box.push(style)
				}
				console.log("aaaaaa", that.sixbox)
			},
			//洗牌
			again() {
				let style = ''
				let that = this
				that.box = []
				let index = 0;
				that.boxflag = 'box-shadow: 0px 0px 0px #d77813;'
				that.flag = false
				var id = setInterval(aa, 150);

				function aa() {
					if (index == 18) {
						clearInterval(id);
						that.inteStyle()
						// setTimeout(function(){
						// 　　that.licensing()
						// 　　},500);　
					} else {
						that.change()
					}
					index++;
				}

			},
			change() {
				let that = this
				let style = ''
				that.box = []
				console.log("that.boxflag", that.boxflag)
				for (let i = 0; i < 70; i++) {
					style = 'left:' + parseFloat(280 + parseInt(Math.random() * (30 - 1 + 1) + 1, 10) * (i / 10)) + 'px;' + 'top:' +
						parseFloat(0 + parseInt(Math.random() * (20 - 1 + 1) + 1, 10)) + 'px;' + 'z-index:' + parseInt(Math.random() *
							(70 - 1 + 1) + 1, 10);
					that.box.push(style)
				}
			},
			//发牌
			licensing(index) {
				let that = this
				let style = ''
				// let index = 1;
				// that.flag = false
				console.log("that.count", that.count)
				let num = that.count - 1
				if (that.count < 70) {

					let data = {
						"code": 'card',
					}
					let requests = request.getQueryData(data || {})
					axios.post('http://test.lfwellness.cn/api_erp/Meting/lucky_card',
						requests).then(function(data) {
						console.log("data", data);
						if (data.data.ResultCode == 200) {
							that.openflag = true
							style = 'transform:scale(0.8) translate(' + 30 +
								'rem,-10rem); transition:transform 0.3s linear;'
							that.box.splice(index, 1, style)
							setTimeout(function() {
								style = 'display:none;'
								that.box.splice(index, 1, style)
								let obj = {}
								obj.name = data.data.Data.u_name
								that.checkImgExists(data.data.Data.nice_url).then(() => {
									console.log('有效链接')
									obj.img = data.data.Data.nice_url
								}).catch(() => {
									console.log('无效链接')
									obj.img = data.data.Data.u_url
								})
								

								// if(data.data.Data.nice_url==''){
								// 	obj.img = data.data.Data.u_url
								// }else{
								// 	obj.img = data.data.Data.nice_url
								// }
								obj.Flag = 'display: block;'
								obj.showFlag = 'background-color: #CF3E24;box-shadow: 5px 5px 15px #888888;'
								obj.isFlipped = true
								that.sixbox.push(obj)

							}, 300);
							that.count++
						} else {
							console.log("啥也没有")
						}
					}).catch(function(err) {
						console.log('err', err);
					});

				} else {
					that.openflag = false
				}

			},
			//中奖名单
			getWin() {
				let that = this
				let data = {
					"type": 1,
				}
				let requests = request.getQueryData(data || {})
				axios.post('http://test.lfwellness.cn/api_erp/Meting/get_win',
					requests).then(function(data) {
					console.log("ZHONGdata", data);
					if (data.data.ResultCode == 200) {
						let length = data.data.Data.length
						that.count = length + 1

						for (let i = 0; i < length; i++) {
							let obj = {}
							obj.name = data.data.Data[i].u_name
							that.checkImgExists(data.data.Data[i].nice_url).then(() => {
								console.log('有效链接')
								obj.img = data.data.Data[i].nice_url
							}).catch(() => {
								console.log('无效链接')
								obj.img = data.data.Data[i].u_url
							})
							obj.Flag = 'display: block;'
							// obj.showFlag = 'background-color: #CF3E24;box-shadow: 5px 5px 15px #888888;'
							obj.isFlipped = true
							that.sixbox.push(obj)

						}
					} else {
						console.log("ZHONG啥也没有")
					}
				}).catch(function(err) {
					console.log('err', err);
				});
			},
			checkImgExists(imgurl) {
				console.log("图片",imgurl)
				return new Promise(function(resolve, reject) {
					var ImgObj = new Image();
					ImgObj.src = imgurl;
					ImgObj.onload = function(res) {
						resolve(res);
					}
					ImgObj.onerror = function(err) {
						reject(err)
					}
				})
			},


			//选牌
			open(index) {
				console.log("index", index)
				let that = this
				let style = ''

				if (that.openflag == true) {
					let str = that.box[index]
					let length = that.box.length
					let num = length - index - 1
					style = str + 'transform:  scale(1.5) translate(' + (14 - num * 6) +
						'rem,10rem); transition:transform 1s linear;z-index:100;'
					that.box.splice(index, 1, style)

					setTimeout(function() {
						let str = that.box[index]
						// style = 'transform:rotateY(180deg) ;transition:transform 1s linear;'
						style = 'display:none;'
						that.box.splice(index, 1, style)
						that.flag = true
						that.openflag = false
						// that.fanzhuan = 'transform:rotate3d(0,1,0, 180deg) ;transition:transform 2s linear;'
					}, 1000);



					setTimeout(function() {
						that.flag = false
						that.openflag = true
					}, 3000);
				}

			},
			//新一轮
			newgame() {
				let that = this
				that.count = 1
				that.sixbox = []

				that.again()
			}




		}

	}
</script>


<style scoped>
	.itembox {
		position: relative;
	}

	.flip-container {
		-webkit-perspective: 1000;
		-moz-perspective: 1000;
		-o-perspective: 1000;
		perspective: 1000;
		min-height: 120px;
		cursor: pointer;
	}

	.front,
	.back {
		backface-visibility: hidden;
		transition: 0.4s;
		transform-style: preserve-3d;
		top: 0;
		left: 0;
		width: 100%;
	}

	.front {}

	.back {
		-webkit-transform: rotateY(-180deg);
		-moz-transform: rotateY(-180deg);
		-o-transform: rotateY(-180deg);
		-ms-transform: rotateY(-180deg);
		transform: rotateY(-180deg);
		position: absolute;
		opacity: 0;
	}

	.flip-container.flipped .back {
		-webkit-transform: rotateY(0deg);
		-moz-transform: rotateY(0deg);
		-o-transform: rotateY(0deg);
		-ms-transform: rotateY(0deg);
		transform: rotateY(0deg);
		opacity: 1;
	}

	.flipped .back {
		-webkit-transform: rotateY(0deg);
		-moz-transform: rotateY(0deg);
		-o-transform: rotateY(0deg);
		-ms-transform: rotateY(0deg);
		transform: rotateY(0deg);
		opacity: 1;
	}

	.flip-container.flipped .front {
		-webkit-transform: rotateY(180deg);
		-moz-transform: rotateY(180deg);
		-o-transform: rotateY(180deg);
		-ms-transform: rotateY(180deg);
		transform: rotateY(180deg);
		opacity: 0;
	}

	.flipped .front {
		-webkit-transform: rotateY(180deg);
		-moz-transform: rotateY(180deg);
		-o-transform: rotateY(180deg);
		-ms-transform: rotateY(180deg);
		transform: rotateY(180deg);
		opacity: 0;
	}


	#canvas {
		width: 100%;
		height: 100%;
	}

	.index {
		width: 100%;
		height: 100%;
		display: flex;
		/* justify-content: center; */
		align-items: center;
		flex-direction: column;
		/* border: 0.0625rem solid red; */
		overflow: hidden;
		background: url(/images/meeting/index.jpg) no-repeat;
		background-position: center 0;
		background-size: cover;
	}

	.sixshell {
		width: 95%;
		height: 30rem;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		flex-wrap: wrap;
		position: relative;
		/* top: 0; */
		z-index: 99999;


	}

	.sixshell .six {
		width: 7rem;
		height: 12.5rem;
		/* margin-top: 7rem; */
		/* border: #000000 1px solid; */
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		margin: 1rem 1rem 0 1rem;
		box-shadow: 0px 0px 30px #d77813;

	}

	.sixshell .six img {
		width: 100%;

	}

	.sixshell .six .headimg {

		width: 95%;
		height: 100%;
		margin: 0 auto;
		overflow: hidden;
		position: absolute;
	}

	.sixshell .six .headimg img {
		width: 100%;
		height: 100%;
	}

	.sixshell .six .name {
		color: white;
		font-size: 1.25rem;
		font-weight: 550;
		/* margin-top: 2rem; */
	}

	.boxshell {
		width: 49.8rem;
		height: 8rem;
		box-shadow: 0px 0px 30px #d77813;
		/* margin-top: 12rem; */
		/* position: relative; */
		position: relative;
		/* top: 40%; */
	}

	.box {
		width: 4.5rem;
		position: absolute;
		/* top: 9rem; */
		left: 10rem;
		/* left: 30%;
		top: 10%; */
		transition: all 0.2s;
		/* border: 1px solid #F0F0F0; */
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari and Chrome */
		-o-transition: all 0.2s;
		/* Opera */
		transform-style: preserve-3d;


	}

	.box img {
		width: 100%;
		display: block;
	}

	.Lucky {
		width: 6.25rem;
		height: 2rem;
		margin-top: 4rem;
		color: white;
		letter-spacing: 0.5rem;
	}

	.bottom {
		display: flex;
		flex-direction: row;
		width: 35%;
		/* margin-top: 24rem; */
		justify-content: space-around;
		position: absolute;
		bottom: 3rem;
	}

	.flip_wrap {
		width: 220px;
		height: 350px;
		margin: 0 auto;
		/* border: #000000 1px solid; */
		position: absolute;
		left: 25%;
		top: 5%;
		z-index: 999;
	}

	.flip_wrap .head_img {
		width: 6.25rem;
		height: 6.25rem;
		border-radius: 50%;
		border: #000000 1px solid;
		margin: 0 auto;
		margin-top: 3rem;
		overflow: hidden;
	}

	.flip_wrap .head_img img {
		width: 100%;
	}

	.flip_wrap .name {
		color: white;
		font-size: 1.875rem;
		font-weight: 550;
		margin-top: 3rem;
	}
</style>
